export const BANKS = [
  {
    name: 'בנק לאומי',
    value: 'leumi',
    website: 'https://www.leumi.co.il/he',
    instructions: [
      'היכנסו לאתר בנק לאומי',
      'הזינו את פרטי הכניסה האישיים',
      "בתפריט בצד ימין בחרו 'הלוואות ומשכנתאות'",
      "לחצו על 'משכנתאות מסמכי הזמנת'",
      "בחרו 'אישור לסילוק יתרות'",
      'המסמך יופיע בתיבת הדואר האישית באתר ביום המחרת',
    ],
    phone: '*6062',
    workingHours: "ימים א'-ה': 08:00-16:00",
  },
  {
    name: 'בנק מזרחי טפחות',
    value: 'mizrahi',
    website: 'https://www.mizrahi-tefahot.co.il/mortgages/',
    instructions: [
      'היכנסו לאתר מזרחי טפחות',
      "לחצו על 'כניסה לחשבון'",
      "לחצו על 'הלוואות ומשכנתאות'",
      "בחרו 'המשכנתא שלי'",
      "כנסו ל'טפסים ואישורים' והזמינו את המסמך",
    ],
    phone: '*8860',
    workingHours: "ימים א'-ה': 08:00-18:30, יום ו': 08:00-13:00",
  },
  {
    name: 'בנק הפועלים',
    value: 'hapoalim',
    website: 'https://www.bankhapoalim.co.il',
    instructions: [
      'היכנסו לאתר בנק הפועלים',
      'הזינו שם משתמש וסיסמה',
      "בחרו באפשרות 'דוח פרטי משכנתאות'",
      'אשרו קבלת דוח',
      'הורידו את הקובץ למחשב',
    ],
    phone: '*2401',
    workingHours: "ימים א'-ה': 08:00-16:00",
  },
  {
    name: 'בנק דיסקונט',
    value: 'discount',
    website: 'https://www.discountbank.co.il',
    instructions: [
      'היכנסו לאתר דיסקונט',
      "לחצו על 'כניסה לחשבונות פרטיים'",
      'הזינו קוד משתמש וסיסמה',
      "בחרו 'משכנתאות' בתפריט הימני",
      "לחצו על כפתור 'פירוט מלא כולל יתרת סילוק (תדפיס)'",
      'הורידו את הקובץ למחשב',
    ],
    phone: '*2009',
    workingHours: "ימים א'-ה': 08:00-17:00, יום ו': 08:00-13:00",
  },
  {
    name: 'בנק מרכנתיל',
    value: 'mercantile',
    website: 'https://www.mercantile.co.il',
    instructions: [
      'היכנסו לאתר מרכנתיל',
      "לחצו על 'כניסה לחשבונות פרטיים'",
      'הזינו קוד משתמש וסיסמה',
      "בחרו 'משכנתאות' בתפריט הימני",
      "לחצו על כפתור 'פירוט מלא כולל יתרת סילוק (תדפיס)'",
      'הורידו את הקובץ למחשב',
    ],
    phone: '*3477',
    workingHours: "א', ג', ה': 08:30-13:45; ב', ד': 08:30-13:00, 16:00-18:15",
  },
  {
    name: 'הבנק הבינלאומי',
    website: 'https://www.fibi.co.il/private/',
    value: 'international',
    phone: '*3533',
  },
  {
    name: 'בנק ירושלים',
    website: 'https://www.bankjerusalem.co.il/',
    value: 'jerusalem',
    phone: '*5726',
    workingHours: "א'-ד': 08:30-15:30; ב', ה': 09:00-14:00, 16:00-18:00",
  },
];
